import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import { clientCache } from '../utils/clientCache';

export const campaignService = {
  async getActiveCampaigns(page = 'ALL') {
    const cacheKey = `campaigns_active_${page}`;

    return clientCache.fetchWithSWR(
      cacheKey,
      async () => {
        try {
          const response = await axios.get(`${API_BASE_URL}/campaigns/active`, {
            params: {
              page: page !== 'ALL' ? page : undefined,
              device: typeof window !== 'undefined' && window.innerWidth < 768 ? 'MOBILE' : 'DESKTOP',
            },
            timeout: 10000,
          });
          return Array.isArray(response.data) ? response.data : [];
        } catch (err) {
          console.error('Error fetching active campaigns:', err);
          return [];
        }
      },
      60 // 60s cache
    );
  },

  async trackCampaign(id, event = 'view') {
    try {
      await axios.post(`${API_BASE_URL}/campaigns/${id}/track`, { event });
    } catch (e) {
      // Non-blocking telemetry
    }
  },
};
